import { isAnnual, isMonthly } from "@/react/helpers/planHelpers";
import { isCurrent } from "@/react/helpers/plansHelpers";
import { eligibleForCurrentPlanCredit } from "@/react/helpers/plansHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { usePlans } from "../../../RegularPlan/PlansContext";
import { usePlanPricing } from "../../../UpgradePlanDetailsWithProrationModal/hooks/usePlanPricing";
import { useAuxiliaryPlans } from "../../../hooks/useAuxiliaryPlans";
import { AnnualSavings } from "./AnnualSavings";
import { CurrentPlanCredit } from "./CurrentPlanCredit";
import { DueToday } from "./DueToday";
import { MonthlyLoss } from "./MonthlyLoss";
import { PlanSavingsSkeleton } from "./PlanSavingsSkeleton";

export const PlanSavings = () => {
  const { selectedPlan } = usePlans();
  const { isCommunityOnTrial } = usePlanStatus();

  const { auxiliarySelectedPlan } = useAuxiliaryPlans();

  const { pricing, isLoadingPricing } = usePlanPricing({
    plan: selectedPlan,
    alternativePlan: auxiliarySelectedPlan,
    isAnnualPlan: isAnnual(selectedPlan?.interval),
    isCommunityOnTrial,
    isPlanLoading: false,
  });

  if (!selectedPlan) return null;
  if (isCurrent(selectedPlan.plan_action)) return null;

  if (isLoadingPricing || !auxiliarySelectedPlan) {
    return <PlanSavingsSkeleton />;
  }

  return (
    <div className="border-primary flex flex-col gap-y-1 border-t pt-4">
      {isAnnual(selectedPlan.interval) && (
        <AnnualSavings selectedPlan={selectedPlan} />
      )}
      {isMonthly(selectedPlan.interval) && (
        <MonthlyLoss auxiliarySelectedPlan={auxiliarySelectedPlan} />
      )}

      {pricing.currentPlanCredit &&
        eligibleForCurrentPlanCredit(selectedPlan) && (
          <CurrentPlanCredit currentPlanCredit={pricing.currentPlanCredit} />
        )}

      {pricing.dueToday && <DueToday dueToday={pricing.dueToday} />}
    </div>
  );
};
